import Assignment from "components/Assignment/Assignment";

export const ASSIGNMENT_MODE_APPRAISAL = "appraisal";
export const ASSIGNMENT_MODE_INSURANCE = "insurance";
export const ASSIGNMENT_APPRAISAL_TITLE = "Assignments for Appraisers";
export const ASSIGNMENT_INSURANCE_TITLE = "Assignments for Field Reps";

export {
    Assignment
};
